// Routes des équipements publics (M19, lot L4-A), reprises par les routes du patrimoine (une seule ligne
// dans Application.tsx). Les chemins fixes précèdent les fiches.
import type { RouteObject } from 'react-router';
import { PageEquipement } from './PageEquipement';
import { PageEquipements } from './PageEquipements';
import { PageReservations } from './PageReservations';

export const routesEquipements: RouteObject[] = [
  { path: '/equipements', element: <PageEquipements /> },
  { path: '/equipements/reservations', element: <PageReservations /> },
  { path: '/equipements/:id', element: <PageEquipement /> },
];
